define("shared/components/shared/ui/cluster-switcher", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="cNA--group__toggle is--open {{if @readonly 'is--readonly'}} {{@additionalClass}}" ...attributes>
    {{#if @tooltip}}
      <EmberTooltip @delay={{330}} @side="top">
        {{@tooltip}}
      </EmberTooltip>
    {{/if}}
    <div class="cNA--group__toggleWrapper e--group__toggle at--enagementAccessGroups__toggle qa--collabs_group_switcher">
      <Shared::Ui::GroupAvatar @group={{this.currentGroup}} @showDropDownIcon={{this.showDropDownIcon}} />
    </div>
  </div>
  
  {{#unless @readonly}}
    <Shared::Ui::EmberDrop
      @constrainToScrollParent={{true}}
      @constrainToWindow={{true}}
      @contentSelector=".e--group__drop"
      @position="top left"
      @target=".e--group__toggle"
      as |emberDrop|
    >
      <div class="o--dropWrapper e--group__drop cNA--group__drop">
        <div class="o--dropBody cNA--group__dropBody">
          <ul class="o--dropBody__list">
            {{#if (and this.isAccountOwner (not @hideGroupCreation))}}
              <li class="o--dropBody__item">
                <LinkTo @route="account.groups" class="o--dropBody__link u--ellipsis">
                  <div class="cNA--group__avatar cNA--group__avatar--add">
                    {{svg-jar "add" class="o--icon--md o--icon--light"}}
                  </div>
                  <div class="cNA--group__info">
                    <span class="o--user__title u--text--light u--ellipsis">
                      {{t "header.navigation.groups.create"}}
                    </span>
                    <span class="o--user__desc u--text--light u--ellipsis">
                      {{t "header.navigation.groups.manage"}}
                    </span>
                  </div>
                </LinkTo>
              </li>
            {{/if}}
            {{#each this.groups as |group|}}
              <Shared::Ui::GroupItem
                @closeMenu={{emberDrop.closeAction}}
                @group={{group}}
                @isSelected={{are-equal this.currentGroup.id group.id}}
              />
            {{/each}}
          </ul>
        </div>
        <div class="o--dropFooter">
          {{#if this.isAccountOwner}}
            <Shared::Link
              @href="https://help.later.com/hc/en-us/articles/360042609854-A-Guide-to-Access-Groups"
              @text={{t "header.navigation.groups.help"}}
              class="u--text--light"
            />
          {{/if}}
        </div>
      </div>
  
    </Shared::Ui::EmberDrop>
  {{/unless}}
  */
  {
    "id": "qEZtjJBL",
    "block": "[[[11,0],[16,0,[29,[\"cNA--group__toggle is--open \",[52,[30,1],\"is--readonly\"],\" \",[30,2]]]],[17,3],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"    \"],[8,[39,1],null,[[\"@delay\",\"@side\"],[330,\"top\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[30,4]],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"  \"],[10,0],[14,0,\"cNA--group__toggleWrapper e--group__toggle at--enagementAccessGroups__toggle qa--collabs_group_switcher\"],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@group\",\"@showDropDownIcon\"],[[30,0,[\"currentGroup\"]],[30,0,[\"showDropDownIcon\"]]]],null],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[51,[30,1]],[[[1,\"  \"],[8,[39,4],null,[[\"@constrainToScrollParent\",\"@constrainToWindow\",\"@contentSelector\",\"@position\",\"@target\"],[true,true,\".e--group__drop\",\"top left\",\".e--group__toggle\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,0],[14,0,\"o--dropWrapper e--group__drop cNA--group__drop\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--dropBody cNA--group__dropBody\"],[12],[1,\"\\n        \"],[10,\"ul\"],[14,0,\"o--dropBody__list\"],[12],[1,\"\\n\"],[41,[28,[37,5],[[30,0,[\"isAccountOwner\"]],[28,[37,6],[[30,6]],null]],null],[[[1,\"            \"],[10,\"li\"],[14,0,\"o--dropBody__item\"],[12],[1,\"\\n              \"],[8,[39,7],[[24,0,\"o--dropBody__link u--ellipsis\"]],[[\"@route\"],[\"account.groups\"]],[[\"default\"],[[[[1,\"\\n                \"],[10,0],[14,0,\"cNA--group__avatar cNA--group__avatar--add\"],[12],[1,\"\\n                  \"],[1,[28,[35,8],[\"add\"],[[\"class\"],[\"o--icon--md o--icon--light\"]]]],[1,\"\\n                \"],[13],[1,\"\\n                \"],[10,0],[14,0,\"cNA--group__info\"],[12],[1,\"\\n                  \"],[10,1],[14,0,\"o--user__title u--text--light u--ellipsis\"],[12],[1,\"\\n                    \"],[1,[28,[35,9],[\"header.navigation.groups.create\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                  \"],[10,1],[14,0,\"o--user__desc u--text--light u--ellipsis\"],[12],[1,\"\\n                    \"],[1,[28,[35,9],[\"header.navigation.groups.manage\"],null]],[1,\"\\n                  \"],[13],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[42,[28,[37,11],[[28,[37,11],[[30,0,[\"groups\"]]],null]],null],null,[[[1,\"            \"],[8,[39,12],null,[[\"@closeMenu\",\"@group\",\"@isSelected\"],[[30,5,[\"closeAction\"]],[30,7],[28,[37,13],[[30,0,[\"currentGroup\",\"id\"]],[30,7,[\"id\"]]],null]]],null],[1,\"\\n\"]],[7]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"o--dropFooter\"],[12],[1,\"\\n\"],[41,[30,0,[\"isAccountOwner\"]],[[[1,\"          \"],[8,[39,14],[[24,0,\"u--text--light\"]],[[\"@href\",\"@text\"],[\"https://help.later.com/hc/en-us/articles/360042609854-A-Guide-to-Access-Groups\",[28,[37,9],[\"header.navigation.groups.help\"],null]]],null],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n  \"]],[5]]]]],[1,\"\\n\"]],[]],null]],[\"@readonly\",\"@additionalClass\",\"&attrs\",\"@tooltip\",\"emberDrop\",\"@hideGroupCreation\",\"group\"],false,[\"if\",\"ember-tooltip\",\"shared/ui/group-avatar\",\"unless\",\"shared/ui/ember-drop\",\"and\",\"not\",\"link-to\",\"svg-jar\",\"t\",\"each\",\"-track-array\",\"shared/ui/group-item\",\"are-equal\",\"shared/link\"]]",
    "moduleName": "shared/components/shared/ui/cluster-switcher.hbs",
    "isStrictMode": false
  });
  let ClusterSwitcherComponent = _exports.default = (_class = class ClusterSwitcherComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
    }
    get currentGroup() {
      return this.auth.currentGroup;
    }
    get groups() {
      return this.auth.groups;
    }
    get isAccountOwner() {
      return this.auth.currentUserModel.isAccountOwner;
    }
    get showDropDownIcon() {
      return !this.args.readonly;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ClusterSwitcherComponent);
});